module.exports = __webpack_public_path__ + "img/30.143a6a78.png";